import { render, staticRenderFns } from "./VabMenuItem.vue?vue&type=template&id=361e3db8&"
import script from "./VabMenuItem.vue?vue&type=script&lang=js&"
export * from "./VabMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports